module.exports = __webpack_public_path__ + "4acba052385930e90c0262d01ebd04a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/suppliers/2.png
// module id = 538
// module chunks = 21 54 55 56 77 79 80 88